module.exports = __webpack_public_path__ + "static/media/portfolio8.669b7811.png";